import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IMatchListStatsPayloadState extends ISagaCb {
    matchListId: string
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const matchListStatsSlice = createSlice({
    name: 'company-statistics/match-list-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMatchListStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const matchListStatsActions = matchListStatsSlice.actions
export default matchListStatsSlice.reducer
